import { OrganizationActionTypes, OrganizationActions } from './organization.actions';
import { IOrganization } from '../../../../commons';

export interface State {
    error: string | null;
    pending: boolean;
    stateData: IOrganization | null;
}

export const initialState: State = {
    error: null,
    pending: false,
    stateData: null
};

export function reducer(state = initialState, action: OrganizationActions): State {
    switch (action.type) {

        case OrganizationActionTypes.LoadOrganizationState: {
            return {
                ...state,
                error: null,
                pending: false
            };
        }

        case OrganizationActionTypes.LoadOrganizationStateSuccess: {
            return {
                error: null,
                pending: false,
                stateData: action.payload
            };
        }

        case OrganizationActionTypes.LoadOrganizationStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        case OrganizationActionTypes.OrganizationScreenErrorReset: {
            return {
                ...state,
                error: null,
                pending: false
            };
        } 

        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getStateData = (state: State) => state.stateData;